// src/pages/Acknow.tsx

import React, {ReactElement, FC} from "react";
import {Box, Typography} from "@mui/material";
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Grid from '@mui/material/Grid';
import {useNavigate} from "react-router-dom";

const Acknow: FC<any> = (): ReactElement => {

    let navigate = useNavigate();
    
    return (
        <Box sx={{
            flexGrow: 1,
            backgroundColor: 'whitesmoke',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'flex-start'
        }}>
            <Grid container>
            <Grid item style={{height: '10px'}} xs={12}/>
            <Grid item xs={1} />
                <Grid item xs={11}>
                    <Typography color="black" variant="h5">
                    Acknowledgements
                    </Typography>
                </Grid>
                <Grid item style={{height: '10px'}} xs={12}/>
                <Grid item xs={1} />
                <Grid item xs={10}>
                    <Typography color="black">
                    <p>This work has made use of data from the European Space Agency (ESA) mission Gaia 
                        (<a href="https://www.cosmos.esa.int/gaia">https://www.cosmos.esa.int/gaia</a>), processed by the Gaia Data Processing and Analysis Consortium 
                        (DPAC, <a href="https://www.cosmos.esa.int/web/gaia/dpac/consortium">https://www.cosmos.esa.int/web/gaia/dpac/consortium</a>). Funding for the DPAC has been 
                        provided by national institutions, in particular the institutions participating in the 
                        Gaia Multilateral Agreement.</p>
                        <p>Galactic cartography by Kevin Jardine (Twitter: <a href="https://twitter.com/galaxy_map">@galaxy_map</a>).</p>
                    </Typography>
                </Grid>
                <Grid item xs={1} />
            </Grid>
        </Box>
    );
};

export default Acknow;